import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';

const ClientRequestsDashboard = ({ onChat, onReview }) => {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchRequests();
  }, []);

  const fetchRequests = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}oosh/service/my-sent-requests`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
      setRequests(res.data);
    } catch (err) {
      toast.error('Failed to load requests');
      console.error(err);
    }
    setLoading(false);
  };

  return (
    <div className="max-w-4xl mx-auto p-6 bg-white shadow-md rounded-lg">
      <h2 className="text-2xl font-bold mb-6 text-blue-600">My Sent Requests</h2>
      {loading && <p className="text-gray-500 text-center">Loading...</p>}
      {requests.map((req) => (
        <div key={req._id} className="border p-4 mb-4 rounded-lg shadow-sm">
          <p><strong>Provider:</strong> {req.providerId?.email || 'Unknown'}</p>
          <p><strong>Service:</strong> {req.serviceName}</p>
          <p><strong>Role:</strong> {req.roleRequested}</p>
          <p><strong>Details:</strong> {req.requestDetails || 'N/A'}</p>
          <p><strong>Status:</strong> {req.status}</p>
          {req.status === 'accepted' && (
            <div className="mt-2 flex gap-2">
              <button
                onClick={() => onChat(req._id)}
                className="bg-blue-500 text-white p-2 rounded-md hover:bg-blue-600"
              >
                Chat
              </button>
              <button
                onClick={() => onReview(req._id)}
                className="bg-purple-500 text-white p-2 rounded-md hover:bg-purple-600"
              >
                Review
              </button>
            </div>
          )}
        </div>
      ))}
      {!loading && requests.length === 0 && (
        <p className="text-gray-500 text-center">No requests sent</p>
      )}
    </div>
  );
};

export default ClientRequestsDashboard;